import script from "./BoxHome.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxHome.vue?vue&type=script&setup=true&lang=js"

import "./BoxHome.vue?vue&type=style&index=0&id=80a985d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80a985d2"]])

export default __exports__